import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=09daadf4&"
import script from "./Office.vue?vue&type=script&lang=ts&"
export * from "./Office.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports